var _excluded = ["__typename"],
  _excluded2 = ["theme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { WrenchTheme } from '@wds/styles';
import isDark from './isDark';
import getFontWeights, { defaultFontWeightOptions as fontWeightOption } from './getFontWeights';
var fontStyleOption = {
  INHERIT: 'inherit',
  INITIAL: 'initial',
  ITALIC: 'italic',
  NORMAL: 'normal',
  OBLIQUE: 'oblique'
};
var textDecorationOption = {
  NONE: 'none',
  UNDERLINE: 'underline'
};
export var breakpoints = {
  'xxs': {
    'max': '480px'
  },
  'xs': {
    'min': '481px',
    'max': '640px'
  },
  'sm': {
    'min': '641px',
    'max': '768px'
  },
  'md': {
    'min': '769px',
    'max': '1024px'
  },
  'lg': {
    'min': '1025px',
    'max': '1200px'
  },
  'xl': {
    'min': '1201px'
  }
};

/** Possible Styles to format */

/**
 * Generic helper to map an Object to a discriminated union of key-value tuples
 *
 * `{a: number, b?: string | null}` -> `["a", number] | ["b", string | null | undefined]`
*/

/**
 * Generic helper to map an Object to a discriminated union of key-value tuples and make the keys non-nullable
 *
 * `{a: number, b?: string | null}` -> `["a", number] | ["b", string]`
 */

var formatStyle = function formatStyle(kvPair, styles) {
  switch (kvPair[0]) {
    case 'fontWeight':
      if (styles.fontFamily) {
        var fontWeights = getFontWeights(styles.fontFamily);
        return _defineProperty({}, kvPair[0], fontWeights[kvPair[1].toLowerCase()]);
      }
      return _defineProperty({}, kvPair[0], fontWeightOption[kvPair[1].toLowerCase()]);
    case 'fontStyle':
      return _defineProperty({}, kvPair[0], fontStyleOption[kvPair[1]]);
    case 'fontFamily':
      if (kvPair[1] === 'National2') {
        // add fallback-fonts and also use Wrench spelling of font: `'National 2'` vs `National2`
        return _defineProperty({}, kvPair[0], WrenchTheme.type.fontFamily.base);
      }
      return _defineProperty({}, kvPair[0], kvPair[1]);
    case 'textDecoration':
      return _defineProperty({}, kvPair[0], textDecorationOption[kvPair[1]]);
    case 'backgroundImage':
      return kvPair[1].url ? _defineProperty({}, kvPair[0], "url(".concat(kvPair[1].url, ")")) : null;
    default:
      if (typeof kvPair[1] === 'object') {
        // format nested data recursively
        return _defineProperty({}, kvPair[0], formatCommonStyle(kvPair[1]));
      }
      return _defineProperty({}, kvPair[0], kvPair[1]);
  }
};
/** Formats data recursively */
var formatCommonStyle = function formatCommonStyle(_ref10) {
  var __typename = _ref10.__typename,
    styles = _objectWithoutProperties(_ref10, _excluded);
  var entries = Object.entries(styles);
  return entries.reduce(function (acc, args) {
    var _ref11 = args,
      _ref12 = _slicedToArray(_ref11, 2),
      key = _ref12[0],
      val = _ref12[1];
    return val === null || val === undefined ? acc : _objectSpread(_objectSpread({}, acc), formatStyle([key, val], styles));
  }, {});
};

/** Standardizes the formatting to be CSS/JSS compatible  */
export var formatEntity = function formatEntity(data) {
  return data && formatCommonStyle(data) || undefined;
};

/** Collapses `Maybe<T>` (`T | null | undefined`) to `T | undefined` */
export var defaultNullToUndefined = function defaultNullToUndefined(arg) {
  return arg === null ? undefined : arg;
};

/** Format GraphQL to Theme representation */
export var formatTheme = function formatTheme() {
  var _response$survey, _artifacts$background;
  var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref13 = (response === null || response === void 0 ? void 0 : (_response$survey = response.survey) === null || _response$survey === void 0 ? void 0 : _response$survey.design) || {},
    theme = _ref13.theme,
    settings = _objectWithoutProperties(_ref13, _excluded2);
  var _ref14 = theme || {},
    _ref14$name = _ref14.name,
    name = _ref14$name === void 0 ? "Default" : _ref14$name,
    selectedColorPalette = _ref14.selectedColorPalette,
    layout = _ref14.layout,
    surveyPage = _ref14.surveyPage,
    surveyTitle = _ref14.surveyTitle,
    pageTitle = _ref14.pageTitle,
    questionTitle = _ref14.questionTitle,
    questionBody = _ref14.questionBody,
    button = _ref14.button,
    error = _ref14.error,
    exitLink = _ref14.exitLink,
    artifacts = _ref14.artifacts,
    isAccessible = _ref14.isAccessible,
    isCustomTheme = _ref14.isCustomTheme;
  var logo = settings.logo,
    progressBar = settings.progressBar;
  var surveyPageBackgroundImage = artifacts === null || artifacts === void 0 ? void 0 : (_artifacts$background = artifacts.background) === null || _artifacts$background === void 0 ? void 0 : _artifacts$background.url;
  var smFont = "'National 2', 'Helvetica Neue', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '游ゴシック', '游ゴシック体', YuGothic, 'Yu Gothic', 'ＭＳ ゴシック', 'MS Gothic', sans-serif";
  var surveyTheme = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    name: name,
    fontFamily: smFont,
    fontSize: {
      body: 16
    },
    fontWeight: fontWeightOption,
    layout: defaultNullToUndefined(layout),
    isAccessible: isAccessible && !isCustomTheme,
    isCustomTheme: isCustomTheme,
    isDark: isDark((selectedColorPalette === null || selectedColorPalette === void 0 ? void 0 : selectedColorPalette.primaryBackgroundColor) || '#fff'),
    surveyPage: _objectSpread(_objectSpread({}, formatEntity(surveyPage)), surveyPageBackgroundImage && {
      backgroundImage: "url(".concat(surveyPageBackgroundImage, ")")
    }),
    surveyTitle: formatEntity(surveyTitle),
    pageTitle: formatEntity(pageTitle),
    questionTitle: formatEntity(questionTitle),
    questionBody: _objectSpread({
      color: selectedColorPalette === null || selectedColorPalette === void 0 ? void 0 : selectedColorPalette.answerColor
    }, formatEntity(questionBody)),
    button: formatEntity(button),
    error: formatEntity(error),
    exitLink: formatEntity(exitLink)
  }, logo && {
    logo: formatEntity(logo)
  }), progressBar && {
    progressBar: formatEntity(progressBar)
  }), formatEntity(selectedColorPalette)), {}, {
    breakpoints: breakpoints
  });
  return surveyTheme;
};
//# sourceMappingURL=helpers.js.map